export default __webpack_public_path__ + "static/media/info.0ac4c9cc.svg";